import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AppInfo } from '@models/manager/service/app';

const searchSlice = createSlice({
  name: 'search',
  initialState: {
    searchApp: null as AppInfo,
  },
  reducers: {
    setSearchApp: (state, { payload: { searchAppInfo } }) => {
      state.searchApp = searchAppInfo;
    },
  },
});

export const { setSearchApp } = searchSlice.actions;
export const searchSliceName = searchSlice.name;
export default searchSlice.reducer;
